import * as d3 from 'd3'

export default class Module {
  private _category: string

  private _name: string

  private _description: string

  private _title: string

  private _image: string

  protected svg: HTMLElement | null

  constructor(category: string, name: string, image: string, title: string, description: string) {
    this._category = category
    this._name = name
    this._image = image
    this._title = title
    this._description = description
    this.svg = null
  }

  get Category(): string {
    return this._category
  }

  get Name(): string {
    return this._name
  }

  get Image(): string {
    return this._image
  }

  get Description(): string {
    return this._description
  }

  get Title(): string {
    return this._title
  }

  async XMLDocument() {
    if (!this.svg) {
      const xml = await d3.xml(this._image)
      this.svg = xml.documentElement
    }
    return this.svg
  }

  static GetTokenizedTransformAttributeValue(transformStr: string) {
    if (transformStr && transformStr.indexOf(')') >= 0) {
      const cleanedUpTransformAttrArr = transformStr.split(')').slice(0, -1)

      return cleanedUpTransformAttrArr.reduce((retObj: any, item) => {
        const transformPair = item.split('(')

        retObj[transformPair[0]] = transformPair[1].split(',')

        return retObj
      }, {})
    }
    return {}
  }

  isRotatable() {
    const rotateClass = d3.select(this.svg).select('.rotate')
    return rotateClass.nodes().length > 0
  }

  rotate(width: number, height: number, direction: boolean): void {
    if (!this.isRotatable()) return
    const transform = Module.GetTokenizedTransformAttributeValue(d3.select(this.svg).select('.rotate').attr('transform'))
    const angle = transform.rotate ? parseInt(transform.rotate[0], 10) : 0
    if (angle % 90 === 0) {
      const rotateAnimation = () => d3.interpolateString(`rotate(${angle},${width / 2},${height / 2})`, `rotate(${angle + (direction ? 90 : -90)},${width / 2},${height / 2})`)
      d3.select(this.svg).selectAll('.rotate')
        .transition()
        .duration(350)
        .attrTween('transform', rotateAnimation)
    }
  }

  select(): void {
    d3.select(this.svg)
      .select("rect[id='container']")
      .style('fill', '#ADD8E6')
  }

  unselect(): void {
    d3.select(this.svg)
      .select("rect[id='container']")
      .style('fill', '#fff')
  }

  remove(): void {
    d3.select(this.svg).remove()
  }
}
